import { Injectable } from '@angular/core';
import { Karyawan } from '../../../models/pegawai/karyawan.model';
import { Observable } from 'rxjs';
import { KaryawanApiService } from '../../api/pegawai/karyawan.api.service';
import { DataService } from '../data.service';

@Injectable({
  providedIn: 'root',
})
export class KaryawanDataService implements DataService<Karyawan> {
  constructor(private karyawanApiService: KaryawanApiService) {}

  public getAll(query?: any): Observable<Karyawan[]> {
    return this.karyawanApiService.getAll(query);
  }

  public getDokter(): Observable<Karyawan[]> {
    return this.karyawanApiService.getDokter();
  }

  public getKasir(): Observable<Karyawan[]> {
    return this.karyawanApiService.getKasir();
  }

  public search(text: string): Observable<Karyawan[]> {
    return this.karyawanApiService.search(text);
  }

  public getById(id: number): Observable<Karyawan> {
    return this.karyawanApiService.getById(id);
  }

  public getByKodeDokterBpjs(kodeBpjs: string): Observable<Karyawan> {
    return this.karyawanApiService.getByKodeDokterBpjs(kodeBpjs);
  }

  public getStaffingHistories(id: number): Observable<any> {
    return this.karyawanApiService.getStaffingHistories(id);
  }

  public getKaryawanSelection(id: number): Observable<Karyawan[]> {
    return this.karyawanApiService.getKaryawanSelection(id);
  }

  public create(data: any, signature?: string): Observable<any> {
    return this.karyawanApiService.create(data, signature);
  }

  public update(id: number, data?: any): Observable<any> {
    return this.karyawanApiService.update(id, data);
  }

  public delete(id: number): Observable<any> {
    return this.karyawanApiService.delete(id);
  }

  public deactivate(id: number, data: any): Observable<any> {
    return this.karyawanApiService.deactivate(id, data);
  }

  public getAkses(id: number): Observable<Karyawan[]> {
    return this.karyawanApiService.getAkses(id);
  }
}
